<template>
  <div class="jin-form-attach">
    <Upload
      class-name="jin-require"
      title="上传简历"
      tips="支持pdf、doc简历格式"
      path="resume/"
      :info="info"
      show-file-list
      show-list
      :limit="1"
      accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      @change="handleChange"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      resume: {}
    }
  },
  computed: {
    ...mapGetters([
      'resumeCon',
      'drafts'
    ])
  },
  methods: {
    ...mapMutations('resume', ['SET_FORM']),
    async handleChange(fileList) {
      const item = fileList[0]
      this.resume = {}
      if (item) {
        this.resume = {
          url: item.url,
          type: item.file.name.split('.')[1],
          file: {
            name: item.file.name,
            size: item.file.size
          }
        }
      }
      if (this.resumeCon.length) {
        const curr = this.resumeCon.map(item => {
          if (item.template === 'Resume') item.form.resume = this.resume
          return item
        })
        this.SET_FORM(curr)
      }
      this.$emit('autoSave')
    },
    resetForm() {
      this.info.form.resume = {}
    },
    submitForm() {
      if (!this.resume.url && !(this.drafts.resume && this.drafts.resume.url)) this.Toast('简历不能为空')
      return !!this.resume.url || !!(this.drafts.resume && this.drafts.resume.url)
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-form {
  &-attach {
    &-con {
      padding: 30px 20px;

      span {
        color: #787b8a;
        line-height: 22px;
      }

      .el-button {
        margin-top: 4px;
        width: 320px;
        height: 42px;
        border-color: #dddfe3;
        background: #dddfe3;
        border-radius: 4px;
        font-size: 14px;
        color: #787b8a;
      }

      .el-upload__tip {
        margin-top: 12px;
        color: #a0a4b7;
        line-height: 20px;
        font-size: 14px;
      }
    }
  }
}
</style>
